import React from 'react';
import styled from 'styled-components';
import {scaleLinear, scaleBand, scaleOrdinal} from 'd3-scale';
import XYAxis from './axis/xy-axis';
import Grid from './grid/grid';
import Line from './line/line';
import Area from './area/area';
import {line, area} from 'd3-shape';
import {extent} from 'd3-array';
import {transition} from 'd3-transition';
import {getAllMonths} from 'localization';

const margins = {
    top: 20,
    right: -70,
    bottom: 50,
    left: 27,
};

const LineChart = ({data, parentWidth, projectType}) => {
    if (parentWidth === 0) return null;

    const width = parentWidth - 24;
    const height = 250 - margins.top - margins.bottom;

    const ticks = 5;
    const t = transition().duration(1000);

    const initialData = data.map((d) => {
        const keys = Object.keys(d);
        const key0 = keys[0];
        const key1 = keys[1];

        return {
            [key0]: d[key0],
            [key1]: 0,
        };
    });

    const months = getAllMonths();

    const monthsScale = scaleOrdinal()
        .domain(data.map(d => d.year))
        .range(months);

    const xScale = scaleBand()
        .domain(data.map(d => d.year))
        .rangeRound([0, width])
        .paddingInner(1);

    const yScale = scaleLinear()
        .domain(extent(data, d => d.count))
        .range([height, 0])
        .nice();

    const lineGenerator = line()
        .x(d => xScale(d.year))
        .y(d => yScale(d.count))


    const areaGenerator = area()
        .x(d => xScale(d.year))
        .y0(height)
        .y1(d => yScale(d.count));

    return (
        <MainWrapper>
            <svg
                className="lineChartSvg"
                width={width - (margins.left + margins.right)}
                height={height + margins.top + margins.bottom}
            >
                <g transform={`translate(${margins.left}, ${margins.top})`}>
                    <XYAxis
                        {...{
                            xScale,
                            yScale,
                            monthsScale,
                            height,
                            ticks,
                            t,
                        }}
                    />
                    <Grid
                        {...{
                            xScale,
                            yScale,
                            width,
                            ticks,
                            t,
                        }}
                    />
                    <Area
                        projectType={projectType}
                        yScale={yScale}
                        initialData={initialData}
                        data={data}
                        areaGenerator={areaGenerator}
                        transition={t}
                    />
                    <Line
                        projectType={projectType}
                        scales={{xScale, yScale}}
                        initialData={initialData}
                        data={data}
                        lineGenerator={lineGenerator}
                    />
                </g>
            </svg>
        </MainWrapper>
    );
};

const MainWrapper = styled.div`
  /* ******** grid ************ */
  .grid-group line {
    stroke: var(--color-grid-line);
    shape-rendering: crispEdges;
    stroke-width: 1px;
    stroke-opacity: .5;
     stroke-dasharray: 4 4;
  }
  .grid-group path {
    stroke-width: 0;
  }
  /* *********** axis  *********** */
  .axis-group path,
  .axis-group line {
    stroke-width: 0;
  }
  .left-axis-group text {
    opacity: 1;
  }
  
  .left-axis-group text,.bottom-axis-group text {
      fill: var(--color-theme-1);
  }
  
  .bottom-axis-group text {
    opacity: 0.5;
    font-size: 12px;
    transform: translate(-8px, 8px) rotate(-40deg);
  }
`;

export default LineChart;



// WEBPACK FOOTER //
// ./src/components/visualization/lineChart/lineChart.js